var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFutureValidity = function SvgFutureValidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "future_validity_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#future_validity_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.025 21.5V20H18.7c.067 0 .133-.033.2-.1s.1-.133.1-.2v-9.4H5v3.95H3.5V6.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h1.4V2.375h1.525V4.5H15.8V2.375h1.5V4.5h1.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v13.4c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525h-3.675ZM8 23.65 6.95 22.6l2.825-2.85H1.25v-1.5h8.525L6.95 15.4 8 14.35 12.65 19 8 23.65ZM5 8.8h14V6.3c0-.067-.033-.133-.1-.2s-.133-.1-.2-.1H5.3c-.067 0-.133.033-.2.1s-.1.133-.1.2v2.5Z",
    fill: "#FFC800"
  }))));
};

export default SvgFutureValidity;